import { CountryInfo } from 'reducers/countries/countriesInfoReducer'

export const findCountryCode = (
  countriesList: CountryInfo[],
  _countryCode: string | null
): CountryInfo | undefined => {
  return countriesList.find(({ countryCode }) => countryCode === _countryCode)
}
